import { PageHeader, Section } from "@/components/site/PageChrome";
import { Ambassador } from "@/components/site/Social";
import { Gift, Users, Megaphone, Trophy } from "lucide-react";

export default function AmbassadorPage() {
  const perks = [
    { icon: Gift, t: "Earn rewards", d: "Get rewarded for every shop and user you onboard to Time2Cash." },
    { icon: Users, t: "Grow your network", d: "Represent Time2Cash and become a recognised community leader in your city." },
    { icon: Megaphone, t: "Run campaigns", d: "Host events and drives with official support and marketing material." },
    { icon: Trophy, t: "Exclusive recognition", d: "Top ambassadors get featured, certified, and invited to special programs." },
  ];
  return (
    <>
      <PageHeader
        eyebrow="Ambassador Program"
        title="Represent Time2Cash in your city."
        subtitle="Help introduce Time2Cash to your community, support local growth, and earn as you grow the movement."
      />
      <Section>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {perks.map(({ icon: Icon, t, d }) => (
            <div key={t} className="rounded-3xl border border-[#EBE8E3] bg-white p-6">
              <div className="w-12 h-12 rounded-2xl bg-[#FFF3ED] flex items-center justify-center">
                <Icon className="w-6 h-6 text-[#FF5A00]" />
              </div>
              <h3 className="mt-4 font-bold text-[#1A1918]">{t}</h3>
              <p className="mt-2 text-sm text-[#4A4846]">{d}</p>
            </div>
          ))}
        </div>
      </Section>
      <Ambassador />
    </>
  );
}
